import { Container } from '@getgo/container-client'

export const isBadgePluginAvailable = () => Container.isPluginAvailable('Badge')
export const isUserIdPluginAvailable = () => Container.isPluginAvailable('UserId')
export const isWindowGroupPluginAvailable = () => Container.isPluginAvailable('WindowGroup')
